import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select-title',
  templateUrl: './select-title.component.html',
  styleUrl: './select-title.component.css'
})
export class SelectTitleComponent {
  @Input() options: any[] = [];          // Lista de opciones
  @Input() placeholder: string = 'Selecciona';  // Placeholder
  selected: any = null;         // Opción seleccionada
  @Input() displayKey: string = 'nombre'; // Propiedad a mostrar en la opción

  @Output() selectedChange = new EventEmitter<any>(); // Evento al seleccionar

  dropdownOpen = false;
  
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any) {
    this.selected = option;
    this.selectedChange.emit(option);
    this.dropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-select-container')) {
      this.dropdownOpen = false;
    }
  }
}
